import { render, staticRenderFns } from "./WalletCarousel.vue?vue&type=template&id=4ccdbd66&scoped=true"
import script from "./WalletCarousel.vue?vue&type=script&lang=js"
export * from "./WalletCarousel.vue?vue&type=script&lang=js"
import style0 from "./WalletCarousel.vue?vue&type=style&index=0&id=4ccdbd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdbd66",
  null
  
)

export default component.exports